import * as React from "react";
import { connect } from "react-redux";
import { Typography } from "../../ecosystem";

const FooterCopyrightVersion = ({
    currentYear,
    applicationVersion,
    typographyColor,
    typographyType,
}) => {

    return <Typography type={typographyType ? typographyType : "meta-01"} color={typographyColor ? typographyColor : ''}>
        © {currentYear} All Rights Reserved Version {applicationVersion}
    </Typography>;

};

const mapStateToProps = state => {
    return {
        applicationVersion: state.session.serverData
            ? state.session.serverData.applicationVersion
            : '1.0.0.0', // we'll default with rendering for mybswhealth
        currentYear:
            state.session.serverData && state.session.serverData.currentYear
                ? state.session.serverData.currentYear
                : '2022',
    }
};

export default connect(mapStateToProps)(FooterCopyrightVersion);